export default class PressureRenderOptions {
  constructor() {
    this.resetToDefault();
  }

  resetToDefault(){
    this.Draw_COP = true;
    this.Draw_COP_Line = true;
    this.Draw_ProcessCOPs = false;
    this.Draw_FrameTime = false;
    this.Draw_ProcessROI = false;
    this.Draw_AxisLine = false;
    this.Draw_WidthLine = false;
    this.Draw_CursorSensor = false;
    this.Draw_HeelLine = false;
    this.Draw_ZonesOverlay = false;
    this.Draw_Zone_FillPolygons = true;
    this.Draw_Zone_Sensors = true;
    this.Draw_Measurements = false;
    this.Draw_Cursors = false;
    this.Draw_DamagedSensors = false;
    this.Draw_Zone_Name = true;
    this.Zones_Alpha = 200;
    this.Draw_Cursor_Name = true;
    this.BlobFiltering = false;
    this.Render_MaxFrame = false;
    this.Render_Raw = false;
    this.FullView = false;
    this.Show_Charts = true;
    this.Show_Play_Button = true;
  }

  setOnlineMode(){
    this.resetToDefault();
    this.Draw_AxisLine = false;
    this.Draw_COP_Line = false;
    this.Draw_Cursors = false;
    this.Draw_CursorSensor = false;
    this.Draw_FrameTime = false;
    this.Draw_HeelLine = false;
    this.Draw_WidthLine = false;
    this.Draw_ZonesOverlay = false;
    this.Draw_Zone_FillPolygons = false;
    this.Draw_Zone_Sensors = false;
    this.Zones_Alpha = 200;
    this.Draw_Measurements = false;
    this.Draw_ProcessCOPs = false;
    this.Show_Charts = false;
    this.BlobFiltering = false;
    this.Show_Play_Button = false;
    this.FullView = true;
  }

  setViewerMode(){
    this.resetToDefault();
  }

   copy() {
     const RO = new PressureRenderOptions();

     RO.Brush_Default = this.Brush_Default;
     RO.ControlPoint_Pen = this.ControlPoint_Pen;
     RO.ControlPoint_Radius = this.ControlPoint_Radius;
     RO.Draw_COP = this.Draw_COP;
     RO.Draw_COP_Line = this.Draw_COP_Line;
     RO.Draw_FrameTime = this.Draw_FrameTime;
     RO.Draw_ProcessROI = this.Draw_ProcessROI;
     RO.Font_Default = this.Font_Default;
     RO.FullView = this.FullView;
     RO.Pen_COP = this.Pen_COP;
     RO.Pen_COP_Line = this.Pen_COP_Line;
     RO.Pen_ROI_Edit = this.Pen_ROI_Edit;
     RO.Pen_ROI_View = this.Pen_ROI_View;
     RO.Render_MaxFrame = this.Render_MaxFrame;
     RO.Render_Raw = this.Render_Raw;
     RO.Draw_AxisLine = this.Draw_AxisLine;
     RO.AxisFrontPerpLineSize = this.AxisFrontPerpLineSize;
     RO.AxisBackPerpLineSize = this.AxisBackPerpLineSize;
     RO.Draw_CursorSensor = this.Draw_CursorSensor;
     RO.CursorSensor_Width = this.CursorSensor_Width;
     RO.Pen_CursorSensor = this.Pen_CursorSensor;
     RO.Draw_WidthLine = this.Draw_WidthLine;
     RO.WidthPerpLineSize = this.WidthPerpLineSize;
     RO.Pen_WidthLine = this.Pen_WidthLine;
     RO.Pen_Axis_Edit = this.Pen_Axis_Edit;
     RO.Draw_HeelLine = this.Draw_HeelLine;
     RO.Draw_ZonesOverlay = this.Draw_ZonesOverlay;
     RO.Zones_Alpha = this.Zones_Alpha;
     RO.Pen_Zones_View = this.Pen_Zones_View;
     RO.Draw_Zone_FillPolygons = this.Draw_Zone_FillPolygons;
     RO.Draw_Zone_Sensors = this.Draw_Zone_Sensors;
     RO.Zones_Sensors_Alpha = this.Zones_Sensors_Alpha;
     RO.BlobFiltering = this.BlobFiltering;
     RO.Pen_helpers = this.Pen_helpers;
     RO.Pen_Measures = this.Pen_Measures;
     RO.Draw_Measurements = this.Draw_Measurements;
     RO.Pen_Linear = this.Pen_Linear;
     RO.Pen_Angular = this.Pen_Angular;
     RO.Pen_Selected = this.Pen_Selected;
     RO.Draw_ProcessCOPs = this.Draw_ProcessCOPs;

     RO.Brush_PolygonAdd = this.Brush_PolygonAdd;
     RO.Pen_Cursors = this.Pen_Cursors;
     RO.Brush_PolygonView = this.Brush_PolygonView;
     RO.Draw_Cursors = this.Draw_Cursors;
     RO.Brush_Measures = this.Brush_Measures;
     RO.Font_Measures = this.Font_Measures;

     RO.Draw_Zone_Name = this.Draw_Zone_Name;
     RO.Zone_Name_Font = this.Zone_Name_Font;
     RO.Zone_Name_Brush = this.Zone_Name_Brush;
     RO.Draw_Cursor_Name = this.Draw_Cursor_Name;
     RO.Pen_COP_Line2 = this.Pen_COP_Line2;
     RO.Draw_DamagedSensors = this.Draw_DamagedSensors;

     return RO;
 }
}
